export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./exclusion.vue?vue&type=template&id=e88c91ce"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/profile/exclusion.vue?vue&type=template&id=e88c91ce
// module id = WI87
// module chunks = 0